/**
 * @generated SignedSource<<735a6726324cf540391d354379eaaa7c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAreaBackgroundRulePanel_AssignProductMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type addAreaBackgroundRulePanel_AssignProductMutation$data = {
  readonly assignProductsToAreaBackgroundRule: {
    readonly result: boolean;
  };
};
export type addAreaBackgroundRulePanel_AssignProductMutation = {
  response: addAreaBackgroundRulePanel_AssignProductMutation$data;
  variables: addAreaBackgroundRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToAreaBackgroundRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "071cdc127636a947640779598f49c39b",
    "id": null,
    "metadata": {},
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addAreaBackgroundRulePanel_AssignProductMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToAreaBackgroundRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "59b87cd349f9a4337ffbef386a3ed96e";

export default node;
